// extracted by mini-css-extract-plugin
module.exports = {"root":"EditorsNote_root__4BdMT","content":"EditorsNote_content__1Z3qD","label":"EditorsNote_label__ylo1v"};